import axios from 'axios';
import { saveAs } from 'file-saver';
const rootUrl = process.env.VUE_APP_API_URL + '/api/'
export function exportExcel(url, filename, data) {
  axios({
    method: 'post',
    url: rootUrl + url,
    data: data, // 请求体数据
    responseType: 'blob', // 重要：设置响应类型为 blob
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem("token"),
      'Content-Type': 'application/json' // 根据实际情况调整内容类型
    }
  })
  .then(response => {
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, filename);
  })
  .catch(error => {
    console.error('Error downloading the file:', error);
  });
}